export default __webpack_public_path__ + "static/media/IkonNounHeart.19624257.svg";